import React, { FC } from 'react';
import { Helmet } from '@okapi/helmet-react';
import { useSelector } from 'react-redux';
import { getSeoProperties } from 'features/page-model/ducks/get-model';
import { getBaseUrl } from 'common/selectors/location';

export const AnalyticsPageMeta: FC = () => {
  const { pageTitle, metakeywords, metadescription } = useSelector(getSeoProperties) || {};
  const favicon = 'https://cdn.lemanapro.ru/lmru/image/upload/other/favicon/favicon.ico';
  const currentUrl = useSelector(getBaseUrl);
  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="keywords" content={metakeywords ?? undefined} />
      <meta name="description" content={metadescription ?? undefined} />
      <meta property="og:title" content={metakeywords ?? undefined} />
      <meta property="og:description" content={metadescription ?? undefined} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <link href={favicon} rel="shortcut icon" type="image/x-icon" />
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
};
